import { motion, AnimatePresence } from 'framer-motion'
import { MdZoomIn } from 'react-icons/md'

const FALLBACK_COLORS = ['#FFB3D9', '#FFE066', '#C4B5FD', '#86EFAC', '#FFB3D9', '#FFE066', '#C4B5FD', '#86EFAC']

/**
 * GalleryGrid — responsive CSS-columns masonry.
 *
 * Props:
 *   items          — array of gallery item objects from WP API
 *   onImageClick   — callback(index: number)
 */
export default function GalleryGrid({ items = [], onImageClick }) {
  return (
    <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
      <AnimatePresence>
        {items.map((item, i) => (
          <motion.button
            key={item.id ?? i}
            layout
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95 }}
            whileHover={{ scale: 1.02 }}
            transition={{ delay: (i % 8) * 0.06, duration: 0.4 }}
            onClick={() => onImageClick(i)}
            className="group block w-full relative overflow-hidden rounded-2xl cursor-pointer break-inside-avoid mb-4"
            style={!item.image?.url ? { backgroundColor: FALLBACK_COLORS[i % FALLBACK_COLORS.length] } : {}}
          >
            {item.image?.url ? (
              <img
                src={item.image.url}
                alt={item.gallery_caption || item.image.alt || ''}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
            ) : (
              <div className="w-full aspect-square flex items-center justify-center text-5xl select-none">
                🎉
              </div>
            )}

            {/* Hover overlay */}
            <div className="absolute inset-0 bg-ink/0 group-hover:bg-ink/55 transition-all duration-300 flex flex-col items-start justify-end p-4">
              <div className="translate-y-4 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300 w-full">
                {item.gallery_caption && (
                  <p className="text-white font-body font-semibold text-sm mb-1 leading-snug">
                    {item.gallery_caption}
                  </p>
                )}
                <div className="flex items-center justify-between">
                  {item.gallery_event_type && (
                    <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary text-white text-xs font-body font-bold">
                      {item.gallery_event_type}
                    </span>
                  )}
                  <MdZoomIn size={22} className="text-white/80 ml-auto" />
                </div>
              </div>
            </div>
          </motion.button>
        ))}
      </AnimatePresence>
    </div>
  )
}
